import { render, staticRenderFns } from "./SettingsCheckbox.vue?vue&type=template&id=67b328f0&scoped=true"
import script from "./SettingsCheckbox.vue?vue&type=script&lang=js"
export * from "./SettingsCheckbox.vue?vue&type=script&lang=js"
import style0 from "./SettingsCheckbox.vue?vue&type=style&index=0&id=67b328f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b328f0",
  null
  
)

export default component.exports